import { initializeApp } from "firebase/app";

export const firebaseConfig = {
  apiKey: "AIzaSyAp1PlLFNBQqavBvzDt-2Mpo803UydQYKI",
  authDomain: "iinima.firebaseapp.com",
  projectId: "iinima",
  storageBucket: "iinima.appspot.com",
  messagingSenderId: "364978257014",
  appId: "1:364978257014:web:dd5f5e4bb0f0352a44b357",
  measurementId: "G-EM7TT0KX93",
};

export default initializeApp(firebaseConfig);
